export default __webpack_public_path__ + "fonts/MyriadPro-Light.d1846886b009a596fef09f1b69f9b548.woff";